const STATES = ["Chhattisgarh", "Jharkhand", "West Bengal", "All over Odisha"];

export default function Coverage() {
  return (
    <section data-testid="coverage-strip" className="border-y border-white/10 bg-surface/60">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-10 md:py-12 flex flex-col md:flex-row md:items-center gap-5 md:gap-12">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-500 shrink-0">
          We roll regularly across
        </p>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
          {STATES.map((s, i) => (
            <span key={s} className="flex items-center gap-6">
              <span className="font-display uppercase font-black text-2xl md:text-3xl text-bone">{s}</span>
              {i < STATES.length - 1 && <span className="inline-block w-2.5 h-2.5 bg-signal rotate-45 shrink-0" />}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
